/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';

import { const_var, params } from "../redux/reducers/reducer";

export const LimitValueOnWall = (valueType, compType, wallName, width, height, positionY, isDrag, clearance, isEndSide) => {    
    const isCmpTypeDOOR = (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") ? true : false;
    let componentDistance = isCmpTypeDOOR ? 0 : const_var.componentDistance;
    const trimHeight = isCmpTypeDOOR ? 0 : 0;
    const alpha = Math.atan(params.p_r_p / 12);

    const frontLeanAlpha = Math.atan(params.b_l_t_r_pF / 12);
    const backLeanAlpha = Math.atan(params.b_l_t_r_pB / 12);
    const leftLeanAlpha = Math.atan(params.b_l_t_r_p / 12);
    const rightLeanAlpha = Math.atan(params.b_l_t_r_pR / 12);
    
    const legDistance = (const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t][params.p_r_s] !== undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5

    const calculateOffset = (val, legDistance) => val % legDistance === 0 ? 0.15 : 0;
    const backStorageoffset = calculateOffset(params.p_d, legDistance);
    const frontLeanStorageoffset = calculateOffset(params.leanF_p_d, legDistance);
    const backLeanStorageoffset = calculateOffset(params.leanB_p_d, legDistance);
    const leftLeanStorageoffset = calculateOffset(params.lean_p_d, legDistance);
    const rightLeanStorageoffset = calculateOffset(params.leanR_p_d, legDistance);

    let F_L_F_S_WallOffset = params.frontLeanStoragePosition === 0 ? 0 : 0.2;
    let B_L_F_S_WallOffset = params.backLeanStoragePosition === 0 ? 0 : 0.2;
    
    let gableFrontOffset;
    if (params.frontLeanStoragePosition === 0) {
        gableFrontOffset = 0.3;
    } else {
        gableFrontOffset = 0;
    }

    let gableBackOffset;
    if (params.backLeanStoragePosition === 0) {
        gableBackOffset = 0.3;
    } else {
        gableBackOffset = 0;
    }

    let gableLeftOffset;
    if (params.leftLeanStoragePosition === 0) {
        gableLeftOffset = 0.1;
    } else {
        gableLeftOffset = 0;
    }

    let gableRightOffset;
    if (params.rightLeanStoragePosition === 0) {
        gableRightOffset = 0.1;
    } else {
        gableRightOffset = 0;
    }

    const trimOffsetHeight = 0;
    let checkCmpWidth, checkCmpHeight = 0;
    let topPos = 0;
    let bottomPos = 0;
    
    let endClearance = 1
    if (clearance && isCmpTypeDOOR) {
        if (isEndSide.includes('end') && clearance.endClearance) {
            endClearance = clearance.endClearance;
        }
        
    }

    if(const_var.crmSetting.is_module_name == "inventory" && const_var.crmSetting.is_Edit && params.m_s_n == 174) endClearance = 0;
    if (valueType === 'model') {
        checkCmpWidth =  width / 2 + const_var.componentDistance;
    } else if (valueType === 'valid' || valueType === 'measurement') {
        checkCmpWidth =  0;
    }

    if (isCmpTypeDOOR) {
        checkCmpHeight = 0;
        topPos = height;
        bottomPos = 0;
    } else {
        checkCmpHeight = height / 2;
        topPos = positionY + height / 2;
        // bottomPos = (const_var.focusedSection !== undefined && const_var.focusedSection === "center") ? height / 2 + componentDistance : 0.5 + componentDistance;
        bottomPos = height / 2 + componentDistance;
        // bottomPos = height / 3 - 0.5 + componentDistance;       //--------This code is for dyanmic poistion of windows ---------//
        bottomPos = Number(bottomPos.toFixed(2))
    }
    
    let regularHeight = 0;
    if (params.p_r_s === 1) regularHeight = const_var.roofRegularDst * 2;
    else regularHeight = 0;

    /************ limit - x */
    let limitX = {min: 0, max: 0};
    if (params.singleSlope) {
        if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
            const maxHeight = params.p_h - trimHeight - endClearance;
            if (topPos <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = -params.p_w / 2 + (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -minValue + checkCmpWidth,
                    max: params.p_w / 2 - checkCmpWidth - componentDistance
                }
            }
        } else if (wallName === 'c_b_b_w' || wallName === 'c_b_b_s_w') {
            const maxHeight = params.p_h - trimHeight - endClearance;
            if (topPos <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = params.p_w / 2 - (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -params.p_w / 2 + checkCmpWidth + componentDistance,
                    max: -minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
            limitX = {
                min: -(params.p_d / 2 - checkCmpWidth),
                max: params.p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'c_b_r_s_w') {
            limitX = {
                min: -(parseInt(params.p_u_t) - params.p_d / 2) - params.endStoragePositionZ + checkCmpWidth,
                max: params.p_d / 2 - params.endStoragePositionZ - checkCmpWidth
            }
        } else if (wallName === 'c_b_l_s_w') {
            limitX = {
                min: -(params.p_d / 2 - checkCmpWidth) + params.endStoragePositionZ,
                max: parseInt(params.p_u_t) - params.p_d / 2 - checkCmpWidth + params.endStoragePositionZ
            }
        } else if (wallName === 'c_b_l_s_f_w') {
            const maxHeight = params.p_h - trimHeight - endClearance;
            if (topPos <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - checkCmpWidth
                }
            } else {
                const minValue = -params.p_w / 2 + (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -minValue + checkCmpWidth,
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_l_s_b_w') {
            const maxHeight = params.p_h - trimHeight - endClearance;
            if (topPos <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + checkCmpWidth,
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = params.p_w / 2 - (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + checkCmpWidth,
                    max: -minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_r_s_f_w') {
            const maxHeight = params.p_h - trimHeight - endClearance;
            if (topPos <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_right) + checkCmpWidth,
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = -params.p_w / 2 + (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -minValue + checkCmpWidth,
                    max: params.p_w / 2 - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_r_s_b_w') {
            const maxHeight = params.p_h - trimHeight - endClearance;
            if (topPos <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_right) - checkCmpWidth
                }
            } else {
                const minValue = params.p_w / 2 - (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -params.p_w / 2 + checkCmpWidth,
                    max: -minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
            const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanR_p_h + regularHeight - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: params.p_w / 2 + checkCmpWidth,
                    max: params.p_w / 2 + params.leanR_p_w - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(rightLeanAlpha);
                limitX = {
                    min: params.p_w / 2 + checkCmpWidth,
                    max: params.p_w / 2 + minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W') {
            const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanR_p_h + regularHeight - trimHeight || (isCmpTypeDOOR && const_var.hightCategory === "leg_height")) {
                limitX = {
                    min: -params.p_w / 2 - params.leanR_p_w + checkCmpWidth,
                    max: -params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(rightLeanAlpha);
                limitX = {
                    min: -params.p_w / 2 - minValue + checkCmpWidth,
                    max: -params.p_w / 2 - checkCmpWidth
                }
            }
        } else if (wallName === 'R_L_R_W') {
            limitX = {
                min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w + checkCmpWidth : -params.leanR_p_pos - params.leanR_p_d / 2 + checkCmpWidth,
                max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w - checkCmpWidth : -params.leanR_p_pos + params.leanR_p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'R_L_R_S_W') {
            limitX = {
                min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) - params.rightLeanStoragePosition + checkCmpWidth,
                max: -params.leanR_p_pos + params.leanR_p_d / 2 - params.rightLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'R_L_L_S_W') {
            limitX = {
                min: params.leanR_p_pos - params.leanR_p_d / 2 + params.rightLeanStoragePosition + checkCmpWidth,
                max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition - checkCmpWidth
            } 
        }
    } else {
        if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w' || wallName === 'c_b_b_s_w') {
            const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - endClearance;
            if (topPos <= params.p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - (checkCmpWidth - 1)),
                    max: minValue - (checkCmpWidth - 1)
                }
            }
        } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
            limitX = {
                min: -(params.p_d / 2 - checkCmpWidth),
                max: params.p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
            const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanF_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -params.p_d / 2 - params.leanF_p_w + checkCmpWidth,
                    max: -params.p_d / 2 - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(frontLeanAlpha);
                limitX = {
                    min: -params.p_d / 2 - minValue + checkCmpWidth,
                    max: -params.p_d / 2 - checkCmpWidth
                }
            }
        } else if (wallName === 'F_L_L_W' || wallName === 'F_L_L_S_W') {
            const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanF_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: params.p_d / 2 + checkCmpWidth,
                    max: params.p_d / 2 + params.leanF_p_w - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(frontLeanAlpha);
                limitX = {
                    min: params.p_d / 2 + checkCmpWidth,
                    max: params.p_d / 2 + minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'F_L_F_W') {
            limitX = {
                min: params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w + checkCmpWidth : params.leanF_p_pos - params.leanF_p_d / 2 + checkCmpWidth,
                max: params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w - checkCmpWidth : params.leanF_p_pos + params.leanF_p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_F_L_B_W'|| wallName === 'G_F_L_B_S_W') {
            const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w / 2 + regularHeight - trimHeight - endClearance;
            let sign = (wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W') ? -1 : 1
            if (topPos <= params.leanF_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.leanF_p_w / 2 - checkCmpWidth) + (params.leanF_p_pos * sign),
                    max: params.leanF_p_w / 2 - checkCmpWidth + (params.leanF_p_pos * sign)
                }  
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(frontLeanAlpha);
                limitX = {
                    min: -(minValue - checkCmpWidth) + (params.leanF_p_pos * sign),
                    max: minValue - checkCmpWidth + (params.leanF_p_pos * sign)
                }
            }
        }
        else if (wallName === 'G_F_L_L_W') {
            limitX = {
                min: params.p_d / 2 + checkCmpWidth,
                max: params.p_d / 2 + params.leanF_p_d - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_R_W') {
            limitX = {
                min: -params.p_d / 2 - params.leanF_p_d + checkCmpWidth,
                max: -params.p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_L_S_W') {
            limitX = {
                min: params.p_d / 2 + params.frontLeanStoragePosition + checkCmpWidth,
                max: params.p_d / 2 + params.frontLeanStoragePosition + parseInt(params.add_storage_front) - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_R_S_W') {
            limitX = {
                min: -params.p_d / 2 - params.frontLeanStoragePosition - parseInt(params.add_storage_front) + checkCmpWidth,
                max: -params.p_d / 2 - params.frontLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
            const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanB_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: params.p_d / 2 + checkCmpWidth,
                    max: params.p_d / 2 + params.leanB_p_w - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(backLeanAlpha);
                limitX = {
                    min: params.p_d / 2 + checkCmpWidth,
                    max: params.p_d / 2 + minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'B_L_B_W' || wallName === 'B_L_R_S_W') {
            const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanB_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -params.p_d / 2 - params.leanB_p_w + checkCmpWidth,
                    max: -params.p_d / 2 - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(backLeanAlpha);
                limitX = {
                    min: -params.p_d / 2 - minValue + checkCmpWidth,
                    max: -params.p_d / 2 - checkCmpWidth
                }
            }
        } else if (wallName === 'B_L_S_W') {
            limitX = {
                min: params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w + checkCmpWidth : -params.leanB_p_pos - params.leanB_p_d / 2 + checkCmpWidth,
                max: params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w - checkCmpWidth : -params.leanB_p_pos + params.leanB_p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W' || wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W') {
            const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w / 2 + regularHeight - trimHeight - endClearance;
            let sign = (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W') ? -1 : 1
            if (topPos <= params.leanB_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.leanB_p_w / 2 - checkCmpWidth) + (params.leanB_p_pos * sign),
                    max: params.leanB_p_w / 2 - checkCmpWidth + (params.leanB_p_pos * sign)
                }  
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(backLeanAlpha);
                limitX = {
                    min: -(minValue - checkCmpWidth) + (params.leanB_p_pos * sign),
                    max: minValue - checkCmpWidth + (params.leanB_p_pos * sign)
                }
            }
        }
      
        
       else if (wallName === 'G_B_L_L_W') {
            limitX = {
                min: params.p_d / 2 + checkCmpWidth,
                max: params.p_d / 2 + params.leanB_p_d - checkCmpWidth
            }
        } else if (wallName === 'G_B_L_R_W') {
            limitX = {
                min: -params.p_d / 2 - params.leanB_p_d + checkCmpWidth,
                max: -params.p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
            const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.leanR_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: params.p_w / 2 + checkCmpWidth,
                    max: params.p_w / 2 + params.leanR_p_w - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(rightLeanAlpha);
                limitX = {
                    min: params.p_w / 2 + checkCmpWidth,
                    max: params.p_w / 2 + minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W') {
            const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight  - endClearance;
            if (topPos <= params.leanR_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -params.p_w / 2 - params.leanR_p_w + checkCmpWidth,
                    max: -params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(rightLeanAlpha);
                limitX = {
                    min: -params.p_w / 2 - minValue + checkCmpWidth,
                    max: -params.p_w / 2 - checkCmpWidth
                }
            }
        } else if (wallName === 'R_L_R_W') {
            limitX = {
                min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w + checkCmpWidth : -params.leanR_p_pos - params.leanR_p_d / 2 + checkCmpWidth,
                max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w - checkCmpWidth : -params.leanR_p_pos + params.leanR_p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W' || wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W') {
            const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w / 2 + regularHeight - trimHeight - endClearance;
            let sign = (wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W') ? 1 : -1
            if (topPos <= params.leanR_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.leanR_p_w / 2 - checkCmpWidth) + (params.leanR_p_pos * sign),
                    max: params.leanR_p_w / 2 - checkCmpWidth + (params.leanR_p_pos * sign)
                }  
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(rightLeanAlpha);
                limitX = {
                    min: -(minValue - checkCmpWidth) + (params.leanR_p_pos * sign),
                    max: minValue - checkCmpWidth + (params.leanR_p_pos * sign)
                }
            }
        }
     
        else if (wallName === 'G_R_L_L_W') {
            limitX = {
                min: params.p_w / 2 + checkCmpWidth,
                max: params.p_w / 2 + params.leanR_p_d - checkCmpWidth
            }
        } else if (wallName === 'G_R_L_R_W') {
            limitX = {
                min: -params.p_w / 2 - params.leanR_p_d + checkCmpWidth,
                max: -params.p_w / 2 - checkCmpWidth
            }
        } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
            const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.lean_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -params.p_w / 2 - params.lean_p_w + checkCmpWidth,
                    max: -params.p_w / 2 - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(leftLeanAlpha);
                limitX = {
                    min: -params.p_w / 2 - minValue + checkCmpWidth,
                    max: -params.p_w / 2 - checkCmpWidth
                }
            }
        } else if (wallName === 'L_L_B_W' || wallName === 'L_L_B_S_W') {
            const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - endClearance;
            if (topPos <= params.lean_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: params.p_w / 2 + checkCmpWidth,
                    max: params.p_w / 2 + params.lean_p_w - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(leftLeanAlpha);
                limitX = {
                    min: params.p_w / 2 + checkCmpWidth,
                    max: params.p_w / 2 + minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'L_L_L_W') {
            limitX = {
                min: params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w + checkCmpWidth : params.lean_p_pos - params.lean_p_d / 2 + checkCmpWidth,
                max: params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w - checkCmpWidth : params.lean_p_pos + params.lean_p_d / 2 - checkCmpWidth
            }
        } else if (wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W') {
            const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w / 2 + regularHeight - trimHeight - endClearance;
            let sign = (wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W') ? -1 : 1
            if (topPos <= params.lean_p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.lean_p_w / 2 - checkCmpWidth) + (params.lean_p_pos * sign),
                    max: params.lean_p_w / 2 - checkCmpWidth + (params.lean_p_pos * sign)
                }  
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(leftLeanAlpha);
                limitX = {
                    min: -(minValue - checkCmpWidth) + (params.lean_p_pos * sign),
                    max: minValue - checkCmpWidth + (params.lean_p_pos * sign)
                }
            }
        }
      
        else if (wallName === 'G_L_L_L_W') {
            limitX = {
                min: params.p_w / 2 + checkCmpWidth,
                max: params.p_w / 2 + params.lean_p_d - checkCmpWidth
            }
        } else if (wallName === 'G_L_L_R_W') {
            limitX = {
                min: -params.p_w / 2 - params.lean_p_d + checkCmpWidth,
                max: -params.p_w / 2 - checkCmpWidth
            }
        } else if (wallName === 'c_b_r_s_w') {
            limitX = {
                min: -(parseInt(params.p_u_t) - params.p_d / 2) - params.endStoragePositionZ + checkCmpWidth,
                max: params.p_d / 2 - params.endStoragePositionZ - checkCmpWidth
            }
        } else if (wallName === 'c_b_l_s_w') {
            limitX = {
                min: -(params.p_d / 2 - checkCmpWidth) + params.endStoragePositionZ,
                max: parseInt(params.p_u_t) - params.p_d / 2 + params.endStoragePositionZ - checkCmpWidth
            }
        } else if (wallName === 'c_b_l_s_f_w') {
            const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - endClearance;
            if (topPos <= params.p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - checkCmpWidth
                }
            } else if (topPos <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - checkCmpWidth),
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - checkCmpWidth),
                    max: minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_l_s_b_w') {
            const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - endClearance;
            if (topPos <= params.p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + checkCmpWidth,
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else if (topPos <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + checkCmpWidth,
                    max: minValue - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - checkCmpWidth),
                    max: minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_r_s_f_w') {
            const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - endClearance;
            if (topPos <= params.p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_right) + checkCmpWidth,
                    max: params.p_w / 2 - checkCmpWidth
                }
            } else if (topPos <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: params.p_w / 2 - parseInt(params.cB_addStorage_right) + checkCmpWidth,
                    max: minValue - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - checkCmpWidth),
                    max: minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'c_b_r_s_b_w') {
            const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - endClearance;
            if (topPos <= params.p_h + regularHeight - trimHeight - endClearance || (isCmpTypeDOOR && const_var.hightCategory === "pitch_height")) {
                limitX = {
                    min: -(params.p_w / 2 - checkCmpWidth),
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_right) - checkCmpWidth
                }
            } else if (topPos <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - checkCmpWidth),
                    max: -params.p_w / 2 + parseInt(params.cB_addStorage_right) - checkCmpWidth
                }
            } else {
                const minValue = (maxHeight - topPos) / Math.tan(alpha);
                limitX = {
                    min: -(minValue - checkCmpWidth),
                    max: minValue - checkCmpWidth
                }
            }
        } else if (wallName === 'F_L_F_S_W') {
            limitX = {
                min: params.leanF_p_pos - params.leanF_p_d / 2 + params.frontLeanStoragePosition + checkCmpWidth,
                max: params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_F_S_W' || wallName === 'G_F_L_B_S_W') {
            limitX = {
                min: -params.leanF_p_w / 2 + checkCmpWidth,
                max: params.leanF_p_w / 2 - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_L_S_W') {
            limitX = {
                min: params.p_d / 2 + params.leanF_p_pos + checkCmpWidth,
                max: params.p_d / 2 + params.leanF_p_pos + parseInt(params.add_storage_front) - checkCmpWidth
            }
        } else if (wallName === 'G_F_L_R_S_W') {
            limitX = {
                min: -params.p_d / 2 - params.leanF_p_pos - parseInt(params.add_storage_front) + checkCmpWidth,
                max: -params.p_d / 2 - params.leanF_p_pos - checkCmpWidth
            }
        } else if (wallName === 'B_L_F_S_W') {
            limitX = {
                min: -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back) - params.backLeanStoragePosition + checkCmpWidth,
                max: -params.leanB_p_pos + params.leanB_p_d / 2 - params.backLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'G_B_L_L_S_W') {
            limitX = {
                min: params.p_d / 2 + params.backLeanStoragePosition + checkCmpWidth,
                max: params.p_d / 2 + params.backLeanStoragePosition + parseInt(params.add_storage_back) - checkCmpWidth
            }
        } else if (wallName === 'G_B_L_R_S_W') {
            limitX = {
                min: -params.p_d / 2 - params.backLeanStoragePosition - parseInt(params.add_storage_back) + checkCmpWidth,
                max: -params.p_d / 2 - params.backLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'R_L_R_S_W') {
            limitX = {
                min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) - params.rightLeanStoragePosition + checkCmpWidth,
                max: -params.leanR_p_pos + params.leanR_p_d / 2 - params.rightLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'R_L_L_S_W') {
            limitX = {
                min: params.leanR_p_pos - params.leanR_p_d / 2 + params.rightLeanStoragePosition + checkCmpWidth,
                max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition - checkCmpWidth
            } 
        } else if (wallName === 'G_R_L_L_S_W') {
            limitX = {
                min: params.p_w / 2 + params.rightLeanStoragePosition + checkCmpWidth,
                max: params.p_w / 2 + params.rightLeanStoragePosition + parseInt(params.add_storage_right) - checkCmpWidth
            }
        } else if (wallName === 'G_R_L_R_S_W') {
            limitX = {
                min: -params.p_w / 2 - params.rightLeanStoragePosition - parseInt(params.add_storage_right) + checkCmpWidth,
                max: -params.p_w / 2 - params.rightLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'L_L_L_S_W') {
            limitX = {
                min: params.lean_p_pos - params.lean_p_d / 2 + params.leftLeanStoragePosition + checkCmpWidth,
                max: params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + params.leftLeanStoragePosition - checkCmpWidth
            }
        } else if (wallName === 'L_L_R_S_W') {
            limitX = {
                min: -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage) - params.leftLeanStoragePosition + checkCmpWidth,
                max: -params.lean_p_pos + params.lean_p_d / 2 - params.leftLeanStoragePosition - checkCmpWidth
            } 
        } else if (wallName === 'G_L_L_L_S_W') {
            limitX = {
                min: params.p_w / 2 + params.leftLeanStoragePosition + checkCmpWidth,
                max: params.p_w / 2 + params.leftLeanStoragePosition + parseInt(params.add_storage) - checkCmpWidth
            }
        } else if (wallName === 'G_L_L_R_S_W') {
            limitX = {
                min: -params.p_w / 2 - params.leftLeanStoragePosition - parseInt(params.add_storage) + checkCmpWidth,
                max: -params.p_w / 2 - params.leftLeanStoragePosition - checkCmpWidth
            }
        } else {
            console.log("### The selected wall name could not be found ###");
            limitX = {
                min: -params.p_w / 2,
                max: params.p_w / 2
            }
        }
    }

    /************ limit - y */
    let limitY = {min: 0, max: 0};
    if (params.singleSlope) {
        if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w' || wallName === 'c_b_b_s_w') {
            let dynamicHeight =  params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight =  params.p_h - trimHeight - Math.tan(alpha) * (params.p_w) - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
            limitY = {
                min: bottomPos,
                max: params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
            limitY = {
                min: bottomPos,
                max: params.p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'c_b_l_s_r_w') {
            limitY = {
                min: bottomPos,
                max: params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
            let dynamicHeight =  params.p_h - trimHeight - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - Math.tan(alpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight =  params.p_h - trimHeight - Math.tan(alpha) * (params.p_w) - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'c_b_r_s_l_w') {
            limitY = {
                min: bottomPos,
                max: params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
            let dynamicHeight =  params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight =  params.p_h - trimHeight - Math.tan(alpha) * (params.p_w) - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        }
        else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W' || wallName === 'R_L_B_S_W') {
            let dynamicHeight =  params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.leanR_p_h + regularHeight - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanR_p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        }
        else if (wallName === 'R_L_L_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w - componentDistance - checkCmpHeight
            }
        }
    } else {
        if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w' || wallName === 'c_b_b_s_w') {
            let dynamicHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h + regularHeight - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
            limitY = {
                min: bottomPos,
                max: params.p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'F_L_R_W' || wallName === 'F_L_L_W' || wallName === 'F_L_R_S_W' || wallName === 'F_L_L_S_W') {
            let dynamicHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.leanF_p_h + regularHeight - trimHeight - checkCmpHeight;
            }
            
            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W' || wallName === 'G_F_L_L_W' || wallName === 'G_F_L_R_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_F_L_R_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanF_p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight,
            }
        } else if (wallName === 'G_F_L_F_W' || wallName === 'G_F_L_B_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_F_L_B_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w / 2 + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width / 2 + componentDistance) - checkCmpHeight
            }
        } else if (wallName === 'B_L_F_W' || wallName === 'B_L_B_W' || wallName === 'B_L_L_S_W' || wallName === 'B_L_R_S_W') {
            let dynamicHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.leanB_p_h + regularHeight - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W' || wallName === 'G_B_L_L_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_L_S_W' || wallName === 'G_B_L_R_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanB_p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_B_W' || wallName === 'G_B_L_F_S_W' || wallName === 'G_B_L_B_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w / 2 + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width / 2 + componentDistance) - checkCmpHeight
            }
        } else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W' || wallName === 'R_L_B_S_W') {
            let dynamicHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.leanR_p_h + regularHeight - trimHeight - checkCmpHeight;
            }

            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W' || wallName === 'G_R_L_L_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_L_S_W' || wallName === 'G_R_L_R_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanR_p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'G_R_L_F_W' || wallName === 'G_R_L_B_W' || wallName === 'G_R_L_F_S_W' || wallName === 'G_R_L_B_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w / 2 + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width / 2 + componentDistance) - checkCmpHeight
            }
        } else if (wallName === 'L_L_F_W' || wallName === 'L_L_B_W' || wallName === 'L_L_F_S_W' || wallName === 'L_L_B_S_W') {
            let dynamicHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - Math.tan(leftLeanAlpha) * (width + componentDistance * 2) - checkCmpHeight;
            if (isCmpTypeDOOR) {
                if(const_var.hightCategory === "pitch_height") dynamicHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - checkCmpHeight;
                else if(const_var.hightCategory === "leg_height") dynamicHeight = params.lean_p_h + regularHeight - trimHeight - checkCmpHeight;
            }
            limitY = {
                min: bottomPos,
                max: dynamicHeight
            }
        } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W' || wallName === 'G_L_L_L_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_L_L_R_S_W') {
            limitY = {
                min: bottomPos,
                max: params.lean_p_h - trimHeight - trimOffsetHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'G_L_L_F_W' || wallName === 'G_L_L_B_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_L_L_B_S_W') {
            limitY = {
                min: bottomPos,
                max: params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - checkCmpHeight
            }
        } else if (wallName === 'c_b_l_s_r_w') {
            let overHeight = 0;
            if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
            } else {
                overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
            }

            limitY = {
                min: bottomPos,
                max: params.p_h + overHeight - componentDistance - checkCmpHeight,
            }
        } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
            if (parseInt(params.cB_addStorage_left) - params.p_w / 2 < width / 2 + componentDistance) {
                let dynamicHeight = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - checkCmpHeight;
                if (isCmpTypeDOOR) {
                    if(const_var.hightCategory === "pitch_height") dynamicHeight = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - checkCmpHeight;
                    else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h + regularHeight - trimHeight - checkCmpHeight;
                }

                limitY = {
                    min: bottomPos,
                    max: dynamicHeight
                }
            } else {
                let dynamicHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - checkCmpHeight;
                if (isCmpTypeDOOR) {
                    if(const_var.hightCategory === "pitch_height") dynamicHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - checkCmpHeight;
                    else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h + regularHeight - trimHeight - checkCmpHeight;
                }

                limitY = {
                    min: bottomPos,
                    max: dynamicHeight
                }
            }
        } else if (wallName === 'c_b_r_s_l_w') {
            let overHeight = 0;
            if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
            } else {
                overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
            }

            limitY = {
                min: bottomPos,
                max: params.p_h + overHeight - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
            if (parseInt(params.cB_addStorage_right) - params.p_w / 2 < width / 2 + componentDistance) {
                let dynamicHeight = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - checkCmpHeight;
                if (isCmpTypeDOOR) {
                    if(const_var.hightCategory === "pitch_height") dynamicHeight = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - checkCmpHeight;
                    else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h + regularHeight - trimHeight - checkCmpHeight;
                }

                limitY = {
                    min: bottomPos,
                    max: dynamicHeight
                }
            } else {
                let dynamicHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - checkCmpHeight;
                if (isCmpTypeDOOR) {
                    if(const_var.hightCategory === "pitch_height") dynamicHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - checkCmpHeight;
                    else if(const_var.hightCategory === "leg_height") dynamicHeight = params.p_h + regularHeight - trimHeight - checkCmpHeight;
                }
                limitY = {
                    min: bottomPos,
                    max: dynamicHeight
                }
            }
        } else if (wallName === 'R_L_L_S_W') {
            limitY = {
                min: bottomPos,
                max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w - componentDistance - checkCmpHeight
            }
        } else if (wallName === 'L_L_R_S_W') {
            limitY = {
                min: bottomPos,
                max: params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w - componentDistance - checkCmpHeight
            }
        }
    }
    
    /************ position - z */
    let positionZ = 0;
    if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
        positionZ = (params.p_d / 2) - 0.1 ;
    } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
        positionZ = params.p_w / 2 - 0.25;
    } else if (wallName === 'c_b_f_s_w') {
        positionZ = parseInt(params.p_u_t) - params.p_d / 2 - 0.25 + backStorageoffset + params.endStoragePositionZ 
    } else if ( wallName === 'c_b_b_s_w') {
        positionZ = params.p_d / 2 - backStorageoffset - params.endStoragePositionZ 
    } else if (wallName === 'c_b_l_s_r_w') {
        positionZ = -params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.25
    } else if (wallName === 'c_b_r_s_l_w') {
        positionZ = -params.p_w / 2 + parseInt(params.cB_addStorage_right) - 0.25
    } else if (wallName === 'F_L_R_W') {
        positionZ = params.leanF_p_pos + params.leanF_p_d / 2 - 0.25;
    } else if (wallName === 'F_L_L_W') {
        positionZ = -params.leanF_p_pos + params.leanF_p_d / 2 - 0.25;
    } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
        positionZ = params.p_d / 2 + params.leanF_p_w - 0.1;
    } else if (wallName === 'G_F_L_F_W') {
        positionZ = params.p_d / 2 + params.leanF_p_d - 0.25;
    } else if (wallName === 'G_F_L_F_S_W') {
        positionZ = params.p_d / 2 + params.frontLeanStoragePosition + parseInt(params.add_storage_front) + gableFrontOffset
    } else if (wallName === 'G_F_L_B_W') {
        positionZ = -params.p_d / 2 - 0.5;
    } else if (wallName === 'G_F_L_B_S_W') {
        positionZ = -params.p_d / 2 - params.frontLeanStoragePosition;
    } else if (wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W') {
        positionZ = -params.leanF_p_pos + params.leanF_p_w / 2 - 0.25
    } else if (wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W') {
        positionZ = params.leanF_p_pos + params.leanF_p_w / 2 - 0.25
    } else if (wallName === 'B_L_F_W') {
        positionZ = params.leanB_p_pos + params.leanB_p_d / 2 - 0.25
    } else if (wallName === 'B_L_B_W') {
        positionZ = -params.leanB_p_pos + params.leanB_p_d / 2 - 0.25
    } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
        positionZ = params.p_d / 2 + params.leanB_p_w - 0.1;
    } else if (wallName === 'G_B_L_F_W') {
        positionZ = params.p_d / 2 + params.leanB_p_d - 0.25;
    } else if (wallName === 'G_B_L_F_S_W') {
        positionZ = params.p_d / 2 + params.backLeanStoragePosition + parseInt(params.add_storage_back) + gableBackOffset
    } else if (wallName === 'G_B_L_B_W') {
        positionZ = -params.p_d / 2 - 0.25;
    } else if (wallName === 'G_B_L_B_S_W') {
        positionZ = -params.p_d / 2 - params.backLeanStoragePosition
    } else if (wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W') {
        positionZ = params.leanB_p_pos + params.leanB_p_w / 2 - 0.25
    } else if (wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W') {
        positionZ = -params.leanB_p_pos + params.leanB_p_w / 2 - 0.25
    } else if (wallName === 'L_L_F_W') {
        positionZ = params.lean_p_pos + params.lean_p_d / 2 - 0.1
    } else if (wallName === 'L_L_B_W') {
        positionZ = -params.lean_p_pos + params.lean_p_d / 2 - 0.1
    } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
        positionZ = params.p_w / 2 + params.lean_p_w - 0.25
    } else if (wallName === 'G_L_L_F_W') {
        positionZ = params.p_w / 2 + params.lean_p_d - 0.25;
    } else if (wallName === 'G_L_L_F_S_W') {
        positionZ = params.p_w / 2 + params.leftLeanStoragePosition + parseInt(params.add_storage) + gableLeftOffset
    } else if (wallName === 'G_L_L_B_W') {
        positionZ = -params.p_w / 2 - 0.35;
    } else if (wallName === 'G_L_L_B_S_W') {
        positionZ = -params.p_w / 2 - params.leftLeanStoragePosition
    } else if (wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W') {
        positionZ = -params.lean_p_pos + params.lean_p_w / 2 - 0.1
    } else if (wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W') {
        positionZ = params.lean_p_pos + params.lean_p_w / 2 - 0.1
    } else if (wallName === 'R_L_F_W') {
        positionZ = params.leanR_p_pos + params.leanR_p_d / 2 - 0.1;
    } else if (wallName === 'R_L_B_W') {
        positionZ = -params.leanR_p_pos + params.leanR_p_d / 2 - 0.1;
    } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
        positionZ = params.p_w / 2 + params.leanR_p_w - 0.25
    } else if (wallName === 'G_R_L_F_W') {
        positionZ = params.p_w / 2 + params.leanR_p_d - 0.25;
    } else if (wallName === 'G_R_L_F_S_W') {
        positionZ = params.p_w / 2 + params.rightLeanStoragePosition + parseInt(params.add_storage_right) + gableRightOffset
    } else if (wallName === 'G_R_L_B_W') {
        positionZ = -params.p_w / 2 - 0.35;
    } else if (wallName === 'G_R_L_B_S_W') {
        positionZ = -params.p_w / 2 - params.rightLeanStoragePosition
    } else if (wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W') {
        positionZ = params.leanR_p_pos + params.leanR_p_w / 2 - 0.1
    } else if (wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W') {
        positionZ = -params.leanR_p_pos + params.leanR_p_w / 2 - 0.1
    } else if (wallName === 'F_L_R_S_W') {
        positionZ = params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) - 0.25 + frontLeanStorageoffset + params.frontLeanStoragePosition + F_L_F_S_WallOffset;
    } else if (wallName === 'F_L_L_S_W') {
        positionZ = -(params.leanF_p_pos - params.leanF_p_d / 2 + 0.25 + params.frontLeanStoragePosition);
    } else if (wallName === 'B_L_L_S_W') {
        positionZ = params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) - 0.25 + backLeanStorageoffset + params.backLeanStoragePosition + B_L_F_S_WallOffset;
    } else if (wallName === 'B_L_R_S_W') {
        positionZ = - (params.leanB_p_pos - params.leanB_p_d / 2 + 0.25 + params.backLeanStoragePosition)
    } else if (wallName === 'R_L_F_S_W') {
        positionZ = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) - 0.25 + rightLeanStorageoffset + params.rightLeanStoragePosition;
    } else if (wallName === 'R_L_B_S_W') {
        positionZ = -(params.leanR_p_pos - params.leanR_p_d / 2 - 0.075 + rightLeanStorageoffset + params.rightLeanStoragePosition);
    } else if (wallName === 'R_L_L_S_W') {
        positionZ = -params.p_w / 2 - 0.25;
    } else if (wallName === 'L_L_F_S_W') {
        positionZ = params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) - 0.25 + leftLeanStorageoffset + params.leftLeanStoragePosition
    } else if (wallName === 'L_L_B_S_W') {
        positionZ = -(params.lean_p_pos - params.lean_p_d / 2 - 0.075 + leftLeanStorageoffset + params.leftLeanStoragePosition);
    } else if (wallName === 'L_L_R_S_W') {
        positionZ = -params.p_w / 2 - 0.25;
    }
    
    /************ rotation - y | dragging plane */
    let plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), positionZ);
    let rotationY = 0;
    if(wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' || wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W' || wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W' || wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W') {
        plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), isDrag ? -(positionZ + 0.3) : -positionZ);
        rotationY = 0;
    } else if (wallName === 'c_b_b_w' || wallName === 'c_b_b_s_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W' || wallName === 'L_L_B_W' || wallName === 'L_L_B_S_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W' || wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W' || wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W' || wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W') {
        plane = new THREE.Plane(new THREE.Vector3(0, 0, -1), isDrag ? -(positionZ + 0.3) : -positionZ);
        rotationY = Math.PI;
    } else if (wallName === 'c_b_r_w' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'R_L_R_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W' || wallName === '' || wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W' || wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W' || wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W' || wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W') {
        plane = new THREE.Plane(new THREE.Vector3(1, 0, 0), isDrag ? -(positionZ + 0.3) : -positionZ);
        rotationY = Math.PI / 2;
    } else if (wallName === 'c_b_l_w' || wallName === 'F_L_L_W' || wallName === 'F_L_L_S_W' || wallName === 'B_L_B_W' || wallName === 'B_L_R_S_W' || wallName === 'L_L_L_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' || wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W') {
        plane = new THREE.Plane(new THREE.Vector3(-1, 0, 0), isDrag ? -(positionZ + 0.3) : -positionZ);
        rotationY = -Math.PI / 2;
    }
    
    const limitX_min = Math.ceil(limitX.min * 100) / 100;
    const limitX_max = Math.ceil(limitX.max * 100) / 100;
    const limitY_min = Math.ceil(limitY.min * 100) / 100;
    const limitY_max = Math.ceil(limitY.max * 100) / 100;
    
    return { limitX : { min : limitX_min, max : limitX_max }, limitY : { min : limitY_min, max: limitY_max }, positionZ, plane, rotationY }
}
